<div>
  <!-- month bar -->

  <ng-template
    [ngIf]="monthBar"
    [ngTemplateOutlet]="monthBar"
    [ngTemplateOutletContext]="{ $implicit: date }"
  ></ng-template>

  <div class="grid grid-cols-7">
    <!-- week bar -->
    <ng-container *ngFor="let week of listOfWeekname">
      <ng-template
        [ngIf]="weekCell"
        [ngTemplateOutlet]="weekCell"
        [ngTemplateOutletContext]="{ $implicit: week }"
      ></ng-template>
      <div *ngIf="!weekCell">{{ 'weekname.day_' + week | translate }}</div>
    </ng-container>
    <!-- date row -->
    <ng-container *ngFor="let date of listOfDate">
      <ng-template
        [ngIf]="dateCell"
        [ngTemplateOutlet]="dateCell"
        [ngTemplateOutletContext]="{ $implicit: date }"
      ></ng-template>

      <div *ngIf="!dateCell">{{ date.date }}</div>
    </ng-container>
  </div>
</div>
